export const PORTAL_API_URL = process.env.REACT_APP_PORTAL_API_URL || `//${window.location.host}`;
export const rewardCatalogEndpoint = `${PORTAL_API_URL}/api/v1/RewardCatalog/Connect`;
